import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import "./styles.css";
import App from "./App";
import { registerServiceWorker } from "./lib/push";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registered at boot so an already-granted device keeps receiving pushes
// without the user having to revisit settings.
registerServiceWorker();
